export const blockIconsTransportationTurnLeftNew = (
	<span className='material-symbols-outlined'>turn_left</span>
);
